// Vendor
import $ from 'jquery';

// Elements
let $el = $('.js-lightbox');
let $cta = $('[data-lightbox]');

import Helpers from 'helpers/util';

// vars
let _lightbox;

class Lightbox {
	constructor($el) {
		this.$wrapper = $('body').find('.home-content-wrapper');
		this.$footer = $('body').find(
			'.home-content-wrapper + .container-fluid'
		);
		this.$el = $el;
		this.$children = this.$el.find('.lightbox-container > div');
		this.$close = this.$el.find('.js-lightbox-close');
		this.$contents = this.$el.find('.lightbox-contents');
		this.$externalLink = $('.js-external-link');
		this.isVisible = false;
		this.offset = 0;

		this.clsVisible = 'is-visible';
		this.clsDisableClose = 'disable-close';
		this.clsModalOpen = 'is-modal-opened';

		if (this.$el.length) {
			this.isVisible = true;
		}

		this.attachEvents();
	}

	attachEvents() {
		this.$close.on('click', (evt) => {
			this.hideHandler(evt);
		});

		this.$el.on('click', (evt) => {
			const openLB = this.$el.find('.is-visible');
			if (openLB.data('lightbox-noclose') !== undefined) {
				return;
			}
			if (!this.$el.hasClass(this.clsDisableClose)) {
				this.hideHandler(evt);
			}
		});

		this.$externalLink.on('click', (evt) => {
			this.hideHandler(evt);
		});

		this.$contents.on('click', (evt) => {
			evt.stopPropagation();
		});
	}

	onOpen() {
		this.offset = $(window).scrollTop();
		// this.$wrapper.css('transform', `translateY(${(this.offset * -1) }px)`);
		// this.$footer.css('transform', `translateY(${(this.offset * -1)}px)`);
		$('body').addClass(this.clsModalOpen);
	}

	onClose() {
		if ($('body').hasClass(this.clsModalOpen)) {
			$('body').removeClass(this.clsModalOpen);
			$(window).scrollTop(this.offset);
			//this.$wrapper.css('transform', '');
			//this.$footer.css('transform', '');
		}
	}

	showHandler(evt) {
		let currentTarget = $(evt.currentTarget);
		let $target = currentTarget.attr('data-lightbox');

		if ($target === 'leavesite') {
			let $externalHyp = currentTarget.attr('href');
			if ($externalHyp) {
				const $innerExtBtn = this.$el
					.find('.js-lightbox-leavesite')
					.find('.js-external-link');

				$innerExtBtn.attr('href', $externalHyp);

				if (currentTarget.hasClass('toaster__link')) {
					$innerExtBtn.addClass('js-external-link--toaster');
				}
			}
		}

		if ($target === 'external-elearning') {
			let $externalHyp = currentTarget.attr('href');
			if ($externalHyp) {
				this.$el
					.find('.js-lightbox-' + $target)
					.find('form')
					.attr('action', $externalHyp);
			}
		}

		if (this.$el.hasClass(this.clsVisible)) {
			this.$el.find('div.is-visible').removeClass(this.clsVisible);
		}

		if ($target) {
			// this.onOpen();
			// this.$el.addClass(this.clsVisible);
			// this.$el.find('.js-lightbox-' + $target).addClass(this.clsVisible);
			this.showWithLightboxName($target);
			Helpers.pubsub.publish('onLightboxShow', currentTarget);
		}
	}

	showWithLightboxName = (name) => {
		this.onOpen();
		this.$el.addClass(this.clsVisible);
		this.$el.find('.js-lightbox-' + name).addClass(this.clsVisible);
	};

	clearSuccess() {
		let $shareConfirm = this.$el.find('#share-confirmation');
		let $shareContent = this.$el.find('#share-content');
		if ($shareConfirm.length && $shareContent.length) {
			$shareConfirm.hide();
			$shareContent.show();
		}
	}

	hideHandler() {
		this.$el.removeClass(this.clsVisible);
		this.$children.removeClass(this.clsVisible);
		this.clearSuccess();
		this.onClose();
	}
}

const _ctaEvents = () => {
	Helpers.pubsub.subscribe('externalLink', (name, evt) => {
		Helpers.pubsub.publish('GAEvent', {
			event: evt,
			gaType: evt.target.getAttribute('data-lightbox'),
		});
		_lightbox.showHandler(evt);
	});

	$cta.on('click', (evt) => {
		evt.preventDefault();
		const attr = evt.target.getAttribute('data-lightbox');

		if (attr === 'leavesite' || attr === 'external-elearning') {
			Helpers.pubsub.publish('GAEvent', {
				event: evt,
				gaType: evt.target.getAttribute('data-lightbox'),
			});
		}
		_lightbox.showHandler(evt);
	});

	Helpers.pubsub.subscribe('open-lightbox', (eventName, name) => {
		_lightbox.showWithLightboxName(name);
	});

	Helpers.pubsub.subscribe('close-lightbox', () => {
		_lightbox.hideHandler();
	});

	const autoOpenLBs = Array.from(
		document.querySelectorAll('[data-lightbox-auto-open]')
	);
	autoOpenLBs.forEach((lb) => {
		const name = lb.getAttribute('data-lightbox-auto-open');
		_lightbox.showWithLightboxName(name);
	});
};

const _init = () => {
	_lightbox = new Lightbox($el);

	if ($cta.length) {
		_ctaEvents();
	}
};

_init();
